import React from 'react';
import { Typography, Violator, PriceBlock, PunchOut, Button } from '@hpi-sox/hpstellar-core';

import useTemplateTheme from '../../../hooks/useTemplateTheme';
import { useMSRPProps, getCustomSaleText } from '../../../hooks/useProductPrice';
import withPageComponents from '../../../page/components/with-page-components';
import ProductJsonLd from './cto-schema-markup';
import AdaptiveImage from '../../../shared/components/adaptive-image';
import { Helpers } from '../../../core/src/helpers';
import Loader from './loader';
import DeliveryMessage from './delivery-message';
import GameFPS from '../game-fps';
import useAddCTOToCart from './useAddCTOToCart';

import './sticky-header.less';

const EMPTY_OBJ = {};

const StickyHeader = ({ baseConfig, device, froggerMessage, trackCustomMetric, ctoSettings }) => {
    const { image, ctaText, shipsText, title, alternateImage, DisplayFPSCalculator } = baseConfig || EMPTY_OBJ;
    const msrp = useMSRPProps({ position: 'bottom-start' });
    const { price: themePriceProps = {} } = useTemplateTheme(['button', 'price']);
    const isMobile = device === 'mobile';
    const shippingMessage = froggerMessage || shipsText;
    const { disableFPS } = ctoSettings || {};
    const displayFPSCalc = !disableFPS && !!DisplayFPSCalculator && !isMobile;
    const { buttonProps, addingToCart, price } = useAddCTOToCart(trackCustomMetric);

    const jsonLD = <ProductJsonLd price={price} />;
    const ctoMobileStyleProps = isMobile ? { style: 'slim' } : null;

    return (
        <div className={`configure-header-container${isMobile ? ' mobile' : ''}${displayFPSCalc ? ' fps-calc' : ''}`}>
            <Loader addingToCart={addingToCart} />
            <div className="configure-header">
                {jsonLD}
                {!isMobile && (
                    <div className={'header-left'}>
                        {image && (
                            <AdaptiveImage
                                src={Helpers.purifyUrl(alternateImage || image)}
                                maxWidth={170}
                                alt={title}
                                prefetch={true}
                            />
                        )}
                        <div className={'configure-shipping'}>
                            <DeliveryMessage />
                            {shippingMessage && (
                                <Typography
                                    variant="bodyS"
                                    className="cust-html"
                                    dangerouslySetInnerHTML={Helpers.createMarkup(shippingMessage)}
                                />
                            )}
                        </div>
                    </div>
                )}
                {displayFPSCalc && <GameFPS />}
                <div className="header-right">
                    {price && !price.error && (
                        <div className="cto-price-container">
                            <PriceBlock
                                {...price}
                                {...themePriceProps}
                                customSaleText={getCustomSaleText(price)}
                                className="priceBlock"
                                msrp={msrp}
                                {...ctoMobileStyleProps}
                            />
                            {price.gmPoints && <PunchOut grossMargin={price.gmPoints} />}
                        </div>
                    )}
                    {price && price.error && <Violator className="price-error" value={price.error} />}
                    {ctaText && price && <Button {...(buttonProps || {})} />}
                </div>
            </div>
        </div>
    );
};
StickyHeader.whyDidYouRender = true;

export default withPageComponents(StickyHeader, {
    components: ['baseConfig', 'shipDate', 'ctoProductInitial', 'froggerMessage', 'ctoSettings'],
    device: true,
});
